import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SoftwarePlanModal } from '@thinknet-gmbh/platform-common-ui';

import { PaymentModal } from 'src/components/payment-modal/';
import { useGetSoftwarePlansForModule } from 'src/hooks/software-plan/get-software-plans.hook';
import { useAuth } from 'src/hooks/auth.hooks';

import { SUBSCRIBE_INFO_DEFAULT_VALUE } from './software-plans-modal.constants';
import { ISoftwarePlansModal, ISubscribeInfo } from './software-plans-modal.interfaces';

const SoftwarePlansModal = ({ subscriptionId, usedEmployeesPlacesCount }: ISoftwarePlansModal) => {
  const { t } = useTranslation('dashboard');
  const [subscribeInfo, setSubscribeInfo] = useState<ISubscribeInfo>(SUBSCRIBE_INFO_DEFAULT_VALUE);
  const { softwarePlans, loading } = useGetSoftwarePlansForModule();
  const { logout } = useAuth();
  const [isPaymentStage, setIsPaymentStage] = useState(false);

  return (
    <>
      {!isPaymentStage && (
        <SoftwarePlanModal
          loading={loading}
          isOpened={!isPaymentStage}
          onFinish={selectedSubscribeInfo => {
            setSubscribeInfo(selectedSubscribeInfo);
            setIsPaymentStage(true);
          }}
          softwarePlans={softwarePlans}
          minCustomerNumber={usedEmployeesPlacesCount}
          initialsSubscribeInfo={{
            ...subscribeInfo,
            ...(usedEmployeesPlacesCount && { customerNumber: usedEmployeesPlacesCount }),
          }}
          t={t}
          logout={logout}
        />
      )}
      {isPaymentStage && (
        <PaymentModal
          isOpened
          title={t('labels.addCard')}
          onClose={() => setIsPaymentStage(false)}
          subtitle={t('labels.addCardDescription')}
          subscribeInfo={{ subscriptionId, ...subscribeInfo }}
        />
      )}
    </>
  );
};

export default SoftwarePlansModal;
